import * as React from "react";
import cx from "classnames";
import "./polizamenu.scss";

var PolizaMenu = function PolizaMenu(props) {
  var poliza = props.poliza,
      activeSection = props.activeSection,
      admin = props.admin;
  var menuList = [{
    title: "Detalle",
    section: "detail",
    link: "/admin/polizas/".concat(poliza.id),
    permission: "poliza_read"
  }, {
    title: "Endosos",
    section: "poliza_endorsements",
    link: "/admin/polizas/".concat(poliza.id, "/poliza_endorsements"),
    permission: "poliza_endorsement_read"
  }, {
    title: "Siniestros",
    section: "claims",
    link: "/admin/polizas/".concat(poliza.id, "/claims"),
    permission: "claim_read"
  }, {
    title: "Pagos",
    section: "poliza_payments",
    link: "/admin/polizas/".concat(poliza.id, "/poliza_payments")
  }, {
    title: "Renovar",
    section: "renew",
    link: "/admin/polizas/".concat(poliza.id, "/renew")
  }, {
    title: "Bitácora",
    section: "bitacora",
    link: "/admin/polizas/".concat(poliza.id, "/bitacora")
  }];
  var menuListFiltered = menuList.filter(function (menu) {
    return admin.is_super_admin || admin.permissions_code.includes(menu.permission) || menu.permission === undefined;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "col-md-12 page-header"
  }, /*#__PURE__*/React.createElement("nav", {
    className: "navbar navbar-default"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "navbar-text"
  }, /*#__PURE__*/React.createElement("b", null, "Poliza N\xBA ", poliza.code))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-8"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "nav nav-pills"
  }, menuListFiltered.map(function (menu) {
    return /*#__PURE__*/React.createElement("li", {
      key: menu.section
    }, /*#__PURE__*/React.createElement("a", {
      className: cx('nav-link', activeSection === menu.section && "active"),
      href: menu.link,
      onClick: function onClick(e) {
        // Asegurar que el clic funcione correctamente
        e.stopPropagation();
        window.location.href = menu.link;
      },
      style: {
        pointerEvents: 'auto',
        cursor: 'pointer'
      }
    }, menu.title));
  }))))));
};

export default PolizaMenu;